import 'whatwg-fetch'
import 'core-js/features/promise'
import 'core-js/features/string/starts-with'
import 'core-js/features/string/ends-with'
import 'core-js/features/array/includes'
import 'core-js/features/array/every'
import 'core-js/features/array/some'
import 'core-js/features/array/find'
import 'core-js/features/symbol'
import 'core-js/features/map'
import 'core-js/features/symbol/iterator'
import 'core-js/features/array/from'
import 'core-js/features/array/flat'
import 'core-js/features/object/values'
import 'core-js/features/set/difference'

// Safari padStart implementation is buggy: https://developer.apple.com/safari/technology-preview/release-notes/
// "Fixed a bug where String.prototype.padStart() and padEnd() would insert null in rare cases"
import padStart from 'core-js-pure/features/string/pad-start'
import { Buffer } from 'buffer'

String.prototype.padStart = function (maxLength, fillString = ' ') { // eslint-disable-line no-extend-native
  return padStart(this, maxLength, fillString, true)
}

window.Buffer = Buffer
window.global = window
